import { type TFunction } from 'i18next';
import { z } from 'zod';

import { HcpSchema } from '@/core/graphql/generated/validation.zod';

import { localSpecialtyArraySchema } from '../localSpecialtyValidation';
import { MultiPrimaryItemSchema } from '../MultiPrimaryItemSchema.validation';

export const ProfessionalSectionSchema = (t?: TFunction) => {
	const raw = HcpSchema().pick({
		hcpType: true,
		statusCda_V: true,
		nhidCda_V: true
	});

	const requiredMsg = t
		? t('This field is required')
		: 'This field is required';

	return z
		.object({
			hcpType: z.string().min(1, { message: requiredMsg }),
			hcpTypeLocal_VId: z.string().nullish(),

			degrees: z.array(MultiPrimaryItemSchema).default([]),
			hcpSpecialties: z.array(MultiPrimaryItemSchema).default([]),

			allSpecLocal_VId: localSpecialtyArraySchema(t, { required: true }),

			statusCda_V: raw.shape.statusCda_V
				.pipe(z.string().catch(''))
				.transform(s => s.trim()),

			nhidCda_V: z.string().nullish(),
			nhid2_V: z.string().nullish()
		})
		.strict();
};

export type ProfessionalSectionValuesIn = z.input<
	ReturnType<typeof ProfessionalSectionSchema>
>;
export type ProfessionalSectionValuesOut = z.output<
	ReturnType<typeof ProfessionalSectionSchema>
>;
